import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-[666px]" }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 gap-5 mb-2" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 gap-5 mb-2" }
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 gap-5 mb-2" }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-2 gap-5 mb-2" }
const _hoisted_6 = { class: "grid grid-cols-1 mb-2" }

import NameField from './Fields/PatientData/NameField.vue';
import SurnameField from './Fields/PatientData/SurnameField.vue';
import EmailField from './Fields/PatientData/EmailField.vue';
import PhoneField from './Fields/PatientData/PhoneField.vue';
import AddressField from './Fields/PatientData/AddressField.vue';
import CityField from './Fields/PatientData/CityField.vue';
import ZipCodeField from './Fields/PatientData/ZipCodeField.vue';
import PeselField from './Fields/PatientData/PeselField.vue';
import HomeNumberField from './Fields/PatientData/HomeNumberField.vue';

export default {
  __name: 'PatientData',
  setup(__props) {


return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(NameField),
      _createVNode(SurnameField)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(EmailField),
      _createVNode(PhoneField)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(AddressField),
      _createVNode(HomeNumberField)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(CityField),
      _createVNode(ZipCodeField)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(PeselField)
    ])
  ]))
}
}

}